import React from "react";
import { isEmpty } from "lodash";
import { Form, Button } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  SearchableList,
  FieldDropSide,
  ManageReportLayout,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
} from "../../../utils";
import { downloadPayrollFrequencyReport } from "../../../services";
import * as fileSaver from "file-saver";

function PayrollFrequencyReport() {
  const formName = manageReportsFormNames.PAYROLL_FREQUENCY_REPORT;
  const fields = formFields[formName];

  const initialValues = {
    payrollFrequencyType: "All",
    payrollFrequencyTypeId: null,
  };

  const payrollFrequencies = [
    { label: "All", value: null },
    { label: "Annual", value: 1 },
    { label: "BiWeekly", value: 2 },
    { label: "Daily", value: 3 },
    { label: "Monthly", value: 4 },
    { label: "Quarterly", value: 5 },
    { label: "SemiAnnual", value: 6 },
    { label: "SemiMonthly", value: 7 },
    { label: "Weekly", value: 8 },
  ];

  const exportReportFile = (payload) => {
    downloadPayrollFrequencyReport(payload)
      .then((response) => {
        const blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        fileSaver.saveAs(
          blob,
          `PayrollFrequencyReport_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch(() => {});
  };

  const onSubmit = (values) => {
    var payload = {
      payrollFrequencyType : values[fields.payrollFrequencyType]
    }
    exportReportFile(payload);
  };

  return (
    <ManageReportLayout rptName="Payroll Frequency Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              setFieldValue,
              handleSubmit,
              setValues,
              values,
              ...rest
            }) => {
              const onStatusChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [],
                  }),
                  [fields.payrollFrequencyTypeId]:
                    value || value === 0 ? parseInt(value) : null,
                  [fields.payrollFrequencyType]:
                    value || value === 0
                      ? payrollFrequencies[value].label
                      : "All",
                });
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex">
                    <div className="mr-2">
                      <Field
                        size="sm"
                        isRequired
                        label="Payroll Frequency"
                        name={fields.payrollFrequencyType}
                        value={values[fields.payrollFrequencyType]}
                        placeholder="Select One"
                        direction="bottom"
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.payrollFrequencyType])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Payroll Frequency"
                            options={payrollFrequencies}
                            onSelect={(value) => onStatusChange(value)}
                            selectedValue={
                              values[fields.payrollFrequencyTypeId]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div>
                      <Button
                        className="mt-12 sort-button"
                        variant="secondary"
                        style={{ marginLeft: "8px", marginTop: "30px" }}
                        type="submit"
                      >
                        Request Report
                      </Button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
}

export default PayrollFrequencyReport;